import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Create, FormTab, TabbedForm } from 'react-admin';
import { FormSpy } from 'react-final-form';

import CreateToolbar from '../../core/components/CreateToolbar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import FundFamilySummary from './FundFamilySummary';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const FundFamilyTitle = ({ record }) => {
  return (
    <FormTitleBar
      type="Fund Family"
      name=""
      status=""
      creation={true}
      statusLabel=""
      showAvatar={true}
      avatarContent={'FF'}
      recordLabel="Fund Family"
    />
  );
};

class FundFamilyCreate extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty(dirty) {
    // Block bnavigation when the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }
  allowNavigationOnSave = () => {
    this.setState({ whenBlockNavigation: false });
  };

  render() {
    const { whenBlockNavigation } = this.state;

    return (
      <React.Fragment>
        <NavigationPrompt when={whenBlockNavigation} creation>
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Create {...this.props} title={<FundFamilyTitle />}>
          <TabbedForm
            toolbar={
              <CreateToolbar
                allowNavigationOnSave={this.allowNavigationOnSave}
              />
            }
            variant="standard"
            margin="normal"
          >
            <FormTab label="Fund Family Details">
              <FundFamilySummary creation={true} />
              <FormSpy
                subscription={{ dirty: true }}
                onChange={props => {
                  this.handleFormIsDirty(props.dirty);
                }}
              />
            </FormTab>
          </TabbedForm>
        </Create>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(FundFamilyCreate);
